import angular from "angular";
import ForecastRulesCtrl from "./ForecastRulesCtrl";
import ForecastRulesOPMListCtrl from "./ForecastRulesOPMListCtrl";
import ForecastRulesService from "./ForecastRulesService";

export default angular
  .module("energis.forecast", [])
  .config(function routes($stateProvider) {
    $stateProvider.state("forecast-rules", {
      url: "/forecast/rules",
      template: require("./forecast-rules.html"),
      controller: ForecastRulesCtrl,
      controllerAs: "ctrl",
      resolve: {
        itemSource: ForecastRulesService => []
      }
    });
    $stateProvider.state("forecast-rules-list-opms", {
      url: "/forecast/rules/opms/:type/:ruleId",
      template: require("./forecast-rules-opm-list.html"),
      controller: ForecastRulesOPMListCtrl,
      controllerAs: "ctrl",
      resolve: {
        itemSource: ForecastRulesService => []
        
      }
    });
  })
  .service("ForecastRulesService", ForecastRulesService).name;



// WEBPACK FOOTER //
// ./src/ForecastRules/index.js